import { Component } from '@angular/core';
import { ControlValueAccessorModel, getProvider } from '../../../Forms/models/control-value-accessor.model';
import { IncludeExcludeEnum } from '../../enums/include-exclude.enum';

@Component({
    selector: 'agpr-filter-include-exclude',
    templateUrl: './filter-include-exclude.component.html',
    styleUrls: ['./filter-include-exclude.component.scss'],
    providers: [getProvider(FilterIncludeExcludeComponent)],
    standalone: false
})
export class FilterIncludeExcludeComponent extends ControlValueAccessorModel<IncludeExcludeEnum>{
    public readonly includeExcludeEnum = IncludeExcludeEnum;
}
